import { useRouter } from "next/router"
import { useTieupToast } from "src/components/hooks/useTieupToast"
import NovelDetailEditor from "src/components/pages/creator/mypage/novels/DetailEditor"
import routes from "routes"
import CreatorMyPageNovelSettingsLayout from "src/components/common/layouts/CreatorMyPageNovelSettingsLayout"
import { useLoading } from "src/components/hooks/useLoading"
import HTMLHead from "src/components/utils/HTMLHead"
import { usePermission } from "src/components/hooks/usePermission"
import { NovelMeta } from "../../../../models/tieup/novel/NovelMets"
import { createNovel } from "../../../../models/tieup/novel/createNovel"

const CreatorMyPageNovelsCreateNovel: React.FC = () => {
  usePermission([2])

  const router = useRouter()
  const { addToastInfo, addToastError } = useTieupToast()
  const { fullScreenLoading } = useLoading()

  const onSubmit = async (values: NovelMeta) => {
    try {
      fullScreenLoading(true)
      // 小説新規作成
      const { id: novelId } = await createNovel({
        ...values,
        readersNumber:
          Number.isSafeInteger(values.readersNumber) && values.readersNumber > 0
            ? values.readersNumber
            : 0,
      })
      // エディタ画面に遷移する
      await router.push(routes.creatorMyPageNovelsNovelNewChapter(novelId))
      addToastInfo("小説を新規作成しました")
      fullScreenLoading(false)
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error)
      fullScreenLoading(false)
      addToastError("プロフィール作成に失敗しました")
    }
  }

  return (
    <CreatorMyPageNovelSettingsLayout navActive="detail">
      <HTMLHead path="creator/mypage/novel-new" />
      <h2 className="p-creatorMypage-title">基本情報</h2>
      <NovelDetailEditor onSubmit={onSubmit} isNew={true} />
    </CreatorMyPageNovelSettingsLayout>
  )
}

export default CreatorMyPageNovelsCreateNovel
